import { useState, useCallback } from 'react';

export const useDelayedRedirect = () => {
  const [redirectModalVisible, setIsModalVisible] = useState(false);
  const closeRedirectModal = useCallback(() => setIsModalVisible(false), []);
  const [redirectModalProps, setRedirectModalProps] = useState({ url: '', target: '_blank' });

  const redirectWithModal = useCallback((url: string, target = '_blank') => {
    setRedirectModalProps({ url, target });
    setIsModalVisible(true);
  }, []);

  return {
    redirectModalProps,
    redirectModalVisible,
    closeRedirectModal,
    redirectWithModal
  };
};
